import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedActionItem: null,
  selectedCategory: null,
  selectedStatus: null,
  selectedDueDate: null,
  selectedPriority: null,
  selectedAssignee: null,
  selectedTarget: null,
  createdOnDate: null,
  page: 0,
  rowsPerPage: 10,
  selectedRows: [],
  singleRowData: [],
  sort: {
    keytoSort: "modified_at",
    direction: "desc",
  },
  actionItemsList: [],
  singleactionItemDetails: [],
  openModalType: null,
  selectedSearchSite: "",
  description: "",
};

const actionItemsSlice = createSlice({
  name: "actionItems",
  initialState,
  reducers: {
    setActionItemsList: (state, action) => {
      state.actionItemsList = action.payload;
    },
    setSelectedActionItem: (state, action) => {
      state.selectedActionItem = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedDueDate: (state, action) => {
      state.selectedDueDate = action.payload;
    },
    setSelectedPriority: (state, action) => {
      state.selectedPriority = action.payload;
    },
    setSelectedAssignee: (state, action) => {
      state.selectedAssignee = action.payload;
    },
    setSelectedTarget: (state, action) => {
      state.selectedTarget = action.payload;
    },
    setCreatedOnDate: (state, action) => {
      state.createdOnDate = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setSingleRowData: (state, action) => {
      state.singleRowData = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload;
    },
    setSelectedSearchSite: (state, action) => {
      state.selectedSearchSite = action.payload;
    },
    setSingleactionItemDetails: (state, action) => {
      state.singleactionItemDetails = action.payload;
    },
    resetSelectedSearchSite: (state) => {
      state.selectedSearchSite = "";
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
  },
});

export const {
  setActionItemsList,
  setSelectedActionItem,
  setSelectedCategory,
  setSelectedStatus,
  setSelectedDueDate,
  setSelectedPriority,
  setSelectedAssignee,
  setSelectedTarget,
  setCreatedOnDate,
  setPage,
  setRowsPerPage,
  setSelectedRows,
  setSingleRowData,
  setSort,
  setOpenModalType,
  setSelectedSearchSite,
  setSingleactionItemDetails,
  resetSelectedSearchSite,
  setDescription,
} = actionItemsSlice.actions;
export default actionItemsSlice.reducer;
